import { AndroidBanner } from '../AndroidBanner';
import { DesktopBanner } from '../DesktopBanner';
import { IOSBanner } from '../IOSBanner';

import { useBanner } from './hooks/useBanner';

type Props = {
	sourceLocation: string;
	iOSBannerEnabled: boolean;
	androidBannerEnabled: boolean;
	desktopBannerEnabled: boolean;
	bottomOffsetPx?: number;
};

export const Banner = ({
	sourceLocation,
	iOSBannerEnabled,
	androidBannerEnabled,
	desktopBannerEnabled,
	bottomOffsetPx,
}: Props): React.JSX.Element | null => {
	const {
		data: { deviceType, bannerVisible },
		actions: { setBannerClosed },
	} = useBanner();

	if (!bannerVisible) return null;

	switch (deviceType) {
		case 'iphone':
			return iOSBannerEnabled ? (
				<IOSBanner sourceLocation={sourceLocation} setBannerClosed={setBannerClosed} bottomOffsetPx={bottomOffsetPx} />
			) : null;
		case 'android':
			return androidBannerEnabled ? (
				<AndroidBanner
					sourceLocation={sourceLocation}
					setBannerClosed={setBannerClosed}
					bottomOffsetPx={bottomOffsetPx}
				/>
			) : null;
		case 'desktop':
			return desktopBannerEnabled ? (
				<DesktopBanner sourceLocation={sourceLocation} setBannerClosed={setBannerClosed} />
			) : null;
		case 'otherMobile':
		case 'unknown':
			return null;
		default:
			return null;
	}
};
